import { makeAutoObservable } from 'mobx'
import utils from '../utils'
import { message } from 'antd'
import { DeparmentRequest } from '../requests/DepartmentRequest'

class DepartmentStore {
  /** Department list */
  departmentList = []
  departmentOriginalList = []
  constructor() {
    makeAutoObservable(this)
  }
  getDepartmentList = () => {
    return new Promise((resolve, reject) => {
      DeparmentRequest.getDepartmentList()
        .then(response => {
          this.departmentList = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getAllDepartmentList = companyCode => {
    return new Promise((resolve, reject) => {
      DeparmentRequest.getAllDepartmentList(companyCode)
        .then(response => {
          const responseData = response.data
          this.departmentList = responseData
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getDepartmentWithUsers = companyCode => {
    return new Promise((resolve, reject) => {
      DeparmentRequest.getDepartmentWithUsers(null, companyCode)
        .then(response => {
          const responseData = response.data
          this.departmentOriginalList = responseData
          responseData.forEach(department => {
            department.title = utils.getNameInCapitalize(
              department.name.toLowerCase()
            )
            department.name = utils.getNameInCapitalize(
              department.name.toLowerCase()
            )
            department.value = department.code
            department.pId = 0
            department.id = department.code
            if (department.users.length !== 0) {
              department.users.forEach(user => {
                responseData.push({
                  title: utils.getNameInCapitalize(
                    user.name_uppercase.toLowerCase()
                  ),
                  name: utils.getNameInCapitalize(
                    user.name_uppercase.toLowerCase()
                  ),
                  value: '' + user.user_name,
                  pId: department.code,
                  isLeaf: true,
                })
              })
            }
          })
          this.departmentList = responseData
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  setDetailedDepartmentList = listData => {
    this.departmentList = listData
  }
  getDepartmentListFromCompanyCode = companyCode => {
    return new Promise((resolve, reject) => {
      DeparmentRequest.getDepartmentListFromCompanyCode(companyCode)
        .then(response => {
          this.departmentList = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  getUserOfDepartment = departmentCode => {
    return new Promise((resolve, reject) => {
      DeparmentRequest.getUserOfDepartment(departmentCode)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          message.error(error.vi)
          reject(error)
        })
    })
  }
  clearDepartmentList = () => {
    this.departmentList = []
    this.departmentOriginalList = []
  }

  setDepartmentList = departmentList => {
    this.departmentList = departmentList
  }

  create = async name => {
    await DeparmentRequest.create(name)
  }

  update = async (code, name) => {
    await DeparmentRequest.update(code, name)
  }

  delete = async code => {
    await DeparmentRequest.delete(code)
  }

  sort = async codes => {
    await DeparmentRequest.sort(codes)
  }
}

const departmentStore = new DepartmentStore()
export default departmentStore
